import CartIcon2 from "../Icons/CartIcon2";
import Dropdown from "./Dropdown";
import { useQuery } from "@tanstack/react-query";
import { GetCart } from "../../api/Cart/GetCart";
import { useEffect, useState } from "react";
import { getUserCountry, hasDiscount } from "../../utils/utils";
import Button from "./Button";
import { Link } from "react-router-dom";
import { useUserDataStore } from "../../stores/user";

const CartDropdown = () => {
  const [country, setCountry] = useState<string | null>(null);
  const { userData } = useUserDataStore();
  useEffect(() => {
    const userCountry = getUserCountry();
    setCountry(userCountry);
  }, []);

  const { data: CartData } = useQuery({
    queryFn: GetCart,
    queryKey: ["cart"],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!userData.id && userData.role !== "sales" && userData.role !== "admin",
  });

  const cart = CartData?.data;
  const hasCartItems = (cart?.courses && cart.courses.length > 0) || (cart?.packages && cart.packages.length > 0) || (cart?.books && cart.books.length > 0)

  return (
    <Dropdown
      indicator={hasCartItems}
      title="Cart"
      orientation="end"
      toggleImage={<CartIcon2 />}
      toggleClassNames="rounded-full text-slate-400 hover:text-red-500 hover:bg-red-500/10 dark:hover:bg-red-500/20 transition-colors duration-300"
    >
      <div className="px-2 pt-2">
        {hasCartItems ? (
          <>
            <div className="pb-2 mb-2 border-b">
              {cart?.courses &&
                cart.courses.map((course) => (
                  <div key={course.id} className="flex gap-2 mb-4">
                    <img
                      src={course.img_url}
                      alt="course"
                      className="w-16 h-16 rounded object-fit"
                    />
                    <div className="flex flex-col justify-between w-full">
                      <h3 className="text-base font-bold">{course.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                        {country === "EG" ? (
                          <>
                            {hasDiscount(course.actualPrice_egp, course.discountPrice_egp)
                              ? course.discountPrice_egp
                              : course.actualPrice_egp}{" "}
                            <span className="text-xs uppercase md:text-sm">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-xs uppercase md:text-sm">
                              $
                            </span>
                            {hasDiscount(course.actualPrice_usd, course.discountPrice_usd)
                              ? course.discountPrice_usd
                              : course.actualPrice_usd}{" "}
                          </>
                        )}
                        {hasDiscount(
                          country === "EG" ? course.actualPrice_egp : course.actualPrice_usd,
                          country === "EG"
                            ? course.discountPrice_egp
                            : course.discountPrice_usd
                        ) && (
                          <>
                            &nbsp;&nbsp;
                            <span className="font-normal text-gray-400 line-through">
                              {country === "EG" ? (
                                <>
                                  {course.actualPrice_egp}
                                  <span className="text-xs uppercase md:text-sm">
                                    LE
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="text-xs uppercase md:text-sm">
                                    $
                                  </span>
                                  {course.actualPrice_usd}
                                </>
                              )}
                            </span>
                          </>
                        )}
                      </h1>
                    </div>
                  </div>
                ))}
              {cart?.packages &&
                cart.packages.map((pack) => (
                  <div key={pack.id} className="flex gap-2 mb-4">
                    <div className="min-h-16 min-w-16">
                      <svg className="w-full h-full rounded-lg object-fit sm:max-w-24 sm:max-h-24 max-h-16 max-w-16" viewBox="0 0 10 6.7">
                        <defs>
                          <clipPath id="top">
                            <polygon points="0 0, 9.9 0, 0 6.6" />
                          </clipPath>
                          <clipPath id="bottom">
                            <polygon points="10 0.1, 10 6.7, 0.1 6.7" />
                          </clipPath>
                        </defs>
                        {pack.courses.map((course, index) => (
                          <image
                            key={course.id}
                            xlinkHref={course.img_url}
                            x="0"
                            y="0"
                            height="6.7"
                            width="10"
                            clipPath={`url(#${index === 1 ? 'top' : 'bottom'})`}
                          />
                        ))}
                      </svg>
                    </div>
                    <div className="flex flex-col justify-between w-full">
                      <h3 className="text-sm font-bold md:text-base">{pack.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                        {country === "EG" ? (
                          <>
                            {hasDiscount(pack.actualPrice_egp, pack.discountPrice_egp)
                              ? pack.discountPrice_egp
                              : pack.actualPrice_egp}{" "}
                            <span className="text-xs uppercase md:text-sm">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-xs uppercase md:text-sm">
                              $
                            </span>
                            {hasDiscount(pack.actualPrice_usd, pack.discountPrice_usd)
                              ? pack.discountPrice_usd
                              : pack.actualPrice_usd}{" "}
                          </>
                        )}
                        {hasDiscount(
                          country === "EG" ? pack.actualPrice_egp : pack.actualPrice_usd,
                          country === "EG"
                            ? pack.discountPrice_egp
                            : pack.discountPrice_usd
                        ) && (
                          <>
                            &nbsp;&nbsp;
                            <span className="font-normal text-gray-400 line-through">
                              {country === "EG" ? (
                                <>
                                  {pack.actualPrice_egp}
                                  <span className="text-xs uppercase md:text-sm">
                                    LE
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="text-xs uppercase md:text-sm">
                                    $
                                  </span>
                                  {pack.actualPrice_usd}
                                </>
                              )}
                            </span>
                          </>
                        )}
                      </h1>
                    </div>
                  </div>
                ))}
              {cart?.courses &&
                cart.books.map((book) => (
                  <div key={book.id} className="flex gap-2 mb-4">
                    <img
                      src={book.img_url}
                      alt="course"
                      className="w-16 h-16 rounded object-fit"
                    />
                    <div className="flex flex-col justify-between w-full">
                      <h3 className="text-base font-bold">{book.name}</h3>
                      <p className="text-sm">Dr. Mohamed Ismael</p>
                      <h1 className="font-bold">
                        {country === "EG" ? (
                          <>
                            {hasDiscount(book.public_EGP_price, book.discountPrice_egp)
                              ? book.discountPrice_egp
                              : book.public_EGP_price}{" "}
                            <span className="text-xs uppercase md:text-sm">
                              LE
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-xs uppercase md:text-sm">
                              $
                            </span>
                            {hasDiscount(book.public_USD_price, book.discountPrice_usd)
                              ? book.discountPrice_usd
                              : book.public_USD_price}{" "}
                          </>
                        )}
                        {hasDiscount(
                          country === "EG" ? book.public_EGP_price : book.public_USD_price,
                          country === "EG"
                            ? book.discountPrice_egp
                            : book.discountPrice_usd
                        ) && (
                          <>
                            &nbsp;&nbsp;
                            <span className="font-normal text-gray-400 line-through">
                              {country === "EG" ? (
                                <>
                                  {book.public_EGP_price}
                                  <span className="text-xs uppercase md:text-sm">
                                    LE
                                  </span>
                                </>
                              ) : (
                                <>
                                  <span className="text-xs uppercase md:text-sm">
                                    $
                                  </span>
                                  {book.public_USD_price}
                                </>
                              )}
                            </span>
                          </>
                        )}
                      </h1>
                    </div>
                  </div>
                ))}

            </div>
            <div>
              {country === "EG" ? (
                <h1 className="text-lg font-bold">Total: {hasDiscount(cart.total_actualPrice_egp, cart.total_discountPrice_egp) ? cart.total_discountPrice_egp : cart.total_actualPrice_egp}LE {hasDiscount(cart.total_actualPrice_egp, cart.total_discountPrice_egp) && <span className="font-normal text-gray-400 line-through">{cart.total_actualPrice_egp}LE</span>}</h1>
              ) : (
                <h1 className="text-lg font-bold">Total: {hasDiscount(cart.total_actualPrice_usd, cart.total_discountPrice_usd) ? cart.total_discountPrice_usd : cart.total_actualPrice_usd}USD {hasDiscount(cart.total_actualPrice_usd, cart.total_discountPrice_usd) && <span className="font-normal text-gray-400 line-through">{cart.total_actualPrice_usd}USD</span>}</h1>
              )}
              <Link to='/cart-checkout'>
                <Button variant="transparent" className="before:!bg-primary hover:text-white !text-base !font-bold !h-11 mt-2 w-full !border-primary !border-2 text-primary rounded-lg"
                >
                  Checkout
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <h1 className="text-lg font-semibold text-center">
            Your cart is empty, Add something to it
          </h1>
        )}
      </div>
    </Dropdown>
  );
};

export default CartDropdown;
